import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EIconSize } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import { useAccountLogout } from 'hooks/auth/useAccountLogout';
import './index.less';

export const Logout = (): ReactElement => {
  const accountLogout = useAccountLogout();
  const { t } = useTranslation();

  return (
    <div
      className="accountModal__logoutButton"
      onClick={() => accountLogout(true)}
    >
      <GlobalIcon
        lib="account"
        name="logout"
        theme="default"
        size={EIconSize._24}
        className="accountModal__logoutButton__icon"
      />
      {t('account.logout')}
    </div>
  );
};
